<script>
    import PrivacyModal from '../../shared_components/modals/PrivacyModal.svelte';
    import axios from 'axios';
    import { openModal } from 'svelte-modals';
    import { onMount } from 'svelte';
    import { getUrlParam } from '../../helpers/url';
    import { formatDate } from '../../helpers/common';
    import { formatMoney } from '../../helpers/common';
    import { parse } from 'date-fns';
    import { getLanguage } from '../../helpers/url';
    import { link } from 'svelte-spa-router';
    import language from '../../lang/language';
    import { OREndpoint } from '../../helpers/consts';

    let bookingDetails;
    let isLoading = true;

    function handleClick() {
        openModal(PrivacyModal);
    }

    onMount(async () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        isLoading = true;
        await axios
            .get(OREndpoint + '/session/get', {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                params: {
                    session_id: getUrlParam('session_id'),
                },
            })
            .then(function (response) {
                if (response.data) {
                    bookingDetails = response.data;
                    console.log(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        isLoading = false;
    });
</script>

<div class="box">
    {#if !isLoading}
        <a
            class="first-button mb-3 d-inline-block"
            href={getLanguage() ? `?lang=${getLanguage()}` : ''}
            >{language.back_to_nara}</a
        >
        <div class="bg nara-season p-3">
            <span class="text-white">
                {language.booking_req_detail_wait}
            </span>
        </div>
        <div class=" bordered nara-season p-3">
            <p>
                {language.booking_req_instructions}
            </p>
            <div class="grey-bg p-3">
                <div class="row m-0">
                    <div class="col-3">
                        <b>{language.booking_reference}</b>
                    </div>
                    <div class="col-9 border-start">
                        {formatDate(
                            bookingDetails.requested_at,
                            'EEEE, dd MMM yyyy hh:mm'
                        )}
                    </div>
                </div>
                <div class="row border-top m-0">
                    <div class="col-3">
                        <b>{language.booking_reference}</b>
                    </div>
                    <div class="col-9 border-start">
                        {bookingDetails.status}
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-6">
                        <div class="border-bottom">
                            <b>{language.booked_by}:</b>
                        </div>
                        <div class="d-flex flex-column">
                            <span
                                ><b>{language.name}:</b>
                                {bookingDetails.session.metadata
                                    .CustomerDetails_firstName +
                                    ' ' +
                                    bookingDetails.session.metadata
                                        .CustomerDetails_lastName}</span
                            >
                            <span
                                ><b>{language.address}:</b>
                                {bookingDetails.session.metadata
                                    .CustomerDetails_address}</span
                            >
                            <span
                                ><b>{language.phone}:</b>
                                {bookingDetails.session.metadata
                                    .CustomerDetails_phone}</span
                            >
                            <span
                                ><b>{language.mobile}:</b>
                                {bookingDetails.session.metadata
                                    .CustomerDetails_mobile}</span
                            >
                            <span
                                ><b>{language.email}:</b>
                                {bookingDetails.session.metadata
                                    .CustomerDetails_email}</span
                            >
                        </div>
                    </div>
                    <div class="col-6 border-start">
                        <div class="border-bottom">
                            <b>{language.supplier_information}:</b>
                        </div>
                        <div class="d-flex flex-column">
                            <span
                                ><b>{language.name}:</b>
                                {bookingDetails.session.metadata
                                    .ProductDetails_SupplierName}</span
                            >
                            <span
                                ><b>{language.address}:</b>
                                {bookingDetails.session.metadata
                                    .ProductDetails_SupplierAddress}</span
                            >
                            <span
                                ><b>{language.phone}:</b>
                                {bookingDetails.session.metadata
                                    .ProductDetails_SupplierPhone}</span
                            >
                            <span
                                ><b>{language.website}:</b>
                                {bookingDetails.session.metadata
                                    .ProductDetails_SupplierWebsite}</span
                            >
                            <span
                                ><b>{language.email}:</b>
                                {bookingDetails.session.metadata
                                    .ProductDetails_SupplierEmail}</span
                            >
                        </div>
                    </div>
                </div>
                <b class="p-2 mt-5 d-inline-block mb-0"
                    >{language.request_to_book}</b
                >
                <div class="row m-0 align-items-start">
                    <div class="col-3">
                        <div class="border-bottom border-top">
                            <b>{language.product}</b>
                        </div>
                        <div class="d-flex flex-column">
                            {bookingDetails.session.metadata
                                .ProductDetails_ProductName}
                        </div>
                    </div>
                    <div class="col-3 border-start">
                        <div class="border-bottom border-top">
                            <b>{language.options_costs}</b>
                        </div>
                        <div class="d-flex flex-column">
                            {bookingDetails.session.metadata
                                .ProductDetails_Adults}
                            {language.adult}
                        </div>
                    </div>
                    <div class="col-3 border-start border-end">
                        <div class="border-bottom border-top">
                            <b>{language.date}</b>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mb-3">
                                <h6 class="mb-0"><b>{language.check_in}</b></h6>
                                <p class="mb-0">
                                    {formatDate(
                                        bookingDetails.session.metadata
                                            .ProductDetails_CommencementDate,
                                        'EEEE, dd MMM yyyy hh:mm'
                                    )}
                                </p>
                            </div>
                            <div class="mb-3">
                                <h6 class="mb-0">
                                    <b>{language.check_out}</b>
                                </h6>
                                <p class="mb-0">
                                    {formatDate(
                                        bookingDetails.session.metadata
                                            .ProductDetails_ConcludeDate,
                                        'EEEE, dd MMM yyyy hh:mm'
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="border-bottom border-top">
                            <b>Totals</b>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="text-right">
                                {bookingDetails.session.metadata
                                    .ProductDetails_CurrentCurrency}
                                {formatMoney(
                                    bookingDetails.session.metadata
                                        .ProductDetails_Price
                                )}
                            </h6>
                        </div>
                    </div>
                    {#if bookingDetails.product_extras && JSON.parse(bookingDetails.product_extras).length > 0}
                        {#each JSON.parse(bookingDetails.product_extras) as extra}
                            <div class="col-3 border-top">
                                {JSON.parse(extra).Name}
                            </div>
                            <div class="col-3 border-top" />
                            <div class="col-3 border-top" />
                            <div class="col-3 border-top border-left">
                                <h6 class="text-right">
                                    {bookingDetails.session.metadata
                                        .ProductDetails_CurrentCurrency}
                                    {formatMoney(JSON.parse(extra).TotalCost)}
                                </h6>
                            </div>
                        {/each}
                    {/if}

                    <div class="col-9 border-end border-top">
                        <h6 class="text-right">{language.total_gst}</h6>
                    </div>
                    <div class="col-3 border-top">
                        <h6 class="text-right">
                            {bookingDetails.session.metadata
                                .ProductDetails_CurrentCurrency}
                            {formatMoney(
                                bookingDetails.session.metadata.TotalPrice
                            )}
                        </h6>
                    </div>
                    <div class="col-9 border-end border-top">
                        <h6 class="text-right">{language.amount_paid}</h6>
                    </div>
                    <div class="col-3 border-top">
                        <h6 class="text-right">
                            {bookingDetails.session.metadata
                                .ProductDetails_CurrentCurrency}
                            0
                        </h6>
                    </div>
                    <div class="col-9 border-end border-top border-bottom">
                        <h6 class="text-right">{language.amount_owing}</h6>
                    </div>
                    <div class="col-3 border-top border-bottom">
                        <h6 class="text-right">
                            {bookingDetails.session.metadata
                                .ProductDetails_CurrentCurrency}
                            {formatMoney(
                                bookingDetails.session.metadata.TotalPrice
                            )}
                        </h6>
                    </div>
                </div>
                <b>{language.specialRequest}</b>
                <br />
                <p>
                    {bookingDetails.session.metadata
                        .CustomerDetails_specialRequest}
                </p>
            </div>

            <div class="p-3">
                <div class="border-bottom mt-3">
                    <h6 class="font-weight-bold">Conditions of Use</h6>
                    <p>condition</p>
                </div>
                <div class="border-bottom mt-3">
                    <h6 class="font-weight-bold">Booking Terms</h6>
                    <p>condition</p>
                </div>
                <div class="border-bottom mt-3">
                    <h6 class="font-weight-bold">TXJ Privacy Policy</h6>
                    <p on:click={handleClick}>Click to view more</p>
                </div>
            </div>
        </div>
    {:else}
        <div class="details__wrapper">
            <div class="details__head background-animate">
                <div class="head__title">...</div>
                <div class="head__info" />
            </div>
            <div class="details__image background-animate" />
            <div class="details__body background-animate" />
        </div>
    {/if}
</div>

<style>
    h6,
    .h6 {
        font-size: 1.5rem;
    }
    .text-right {
        text-align: right;
    }

    .grey-bg {
        background-color: #eee;
    }
    .bordered {
        border-width: 1px;
        border-style: solid;
    }
</style>
